export default __webpack_public_path__ + "media/storefront/features/hymns/hymns/Guatemala-daa030758e2122c8c025ffe20d7af4f1.mp3";